import { Table } from "antd";
import React from "react";
import moment from 'moment'
import Delete from "../../../../assets/images/delete_icon.svg";

const TableSection = (props) => {
    const { onDelete, onReactive, userList, setDefaultPage, defaultPage } = props;

    const formatPhoneNumber =(phone)=> {
      // Remove all non-digit characters
      const cleaned = phone.replace(/\D/g, "");
    
      // Ensure it's at least 10 digits
      if (cleaned.length !== 10) return phone;
    
      const part1 = cleaned.slice(0, 3);
      const part2 = cleaned.slice(3, 6);
      const part3 = cleaned.slice(6, 10);
    
      return `(${part1}) ${part2} - ${part3}`;
    }
    
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '35%' ,
            render:(field, record) => {
              return <div className="img_column">
                <img src={record.photo_url} height="22px" alt="" />
                <span className="emp_name">{field}</span>
              </div>
            } 
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: '25%'
        },
        {
          title: 'Phone No.',
          dataIndex: 'phone_number',
          key: 'phone_number',
          width: '20%',
          render:(field) => {
            return <div>{formatPhoneNumber(field)}</div>
          }
        },
        {
          title: 'Emp Type',
          dataIndex: 'restaurant_role',
          key: 'restaurant_role',
          width: '10%',
          render:(field) => {
            return <div>{field?.employee_type?.name}</div>
          }
        },
        {
          title: 'Emp ID',
          dataIndex: 'restaurant_role',
          key: 'restaurant_role',
          width: '10%',
          render:(field) => {
            return <div>{field.employee_id}</div>
          }
        },
        {
            title: '',
            width: '15%', 
            render: (_, record) => {
                return <div
                    style={{
                        display: "flex", width: '100px'}}>
                        <>
                            <button className="reactive_btn" onClick={()=>{ onReactive(record) }}>ReActivate</button>
                        </>
                </div>
            }
        }
      ]
    return <div className="table_section">
    <Table columns={columns} 
      bordered 
      dataSource={userList?.employees}
     className="customise-table overflow-auto" 
     pagination={{
      onChange: page =>{
        setDefaultPage(page);
      },
      current: defaultPage,
      pageSize: 10,
      total: userList?.total,
      hideOnSinglePage: true,
      showSizeChanger: false
    }}
     />
  </div>
};
export default TableSection;